<template>
<div class="intro">
  <div>
    <img v-if="logo !== null" :src="logo" alt="logo" class="logo" />
    <div v-html="introText"></div>
    <div v-if="!isOpen" v-html="closedText"></div>
  </div>
  <div class="buttons">
    <v-btn
      v-if="isOpen"
      class="submit-button"
      color="primary"
      @click="$emit('continue')">
      {{ continueButton }}
    </v-btn>
  </div>
  <div class="fineprint">
    <a href="/terms" target="_blank">terms &amp; conditions</a><br/>
    <a href="/terms" target="_blank">privacy policy</a>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Introduction',
  computed: {
    ...mapState([
      'logo',
      'introText',
      'continueButton',
      'nodes',
      'closedText',
    ]),
    isOpen() {
      return Object.keys(this.nodes).length > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/_variables.scss";

.intro {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
  padding: 1.5rem 1.5rem 1.5rem 1.5rem;

  .logo {
    display: block;
    max-width: 340px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2rem;
  }

  .buttons {
    display: flex;
    width: 100%;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-self: center;
    padding-bottom: 10px;
  }

  .fineprint {
    font-size: 10px;
    margin-top: -53px;
    margin-left: 20px;
    color: #CCC;
    a {
      color: #CCC;
      text-decoration: none;
    }
    a:hover {
      text-decoration: underline;
    }
  }
}

@media (min-width: $breakpoint-tablet) {
  .intro {
    justify-content: flex-start;

    .buttons {
      margin-top: 3rem;
    }

    .fineprint {
      position: fixed;
      bottom: 10px;
      left: 10px;
      margin-top: 0px;
    }
  }
}
</style>
